import { createAuth0 } from '@auth0/auth0-vue'

export const auth0 = createAuth0({
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_API_IDENTIFIER,
    redirect_uri: window.location.origin,
  },
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
})
